<template>
  <div
    class="content"
    v-loading="loading"
    element-loading-text="资源上传中"
    element-loading-spinner="el-icon-loading"
  >
    <div class="header">
      <el-button type="primary" plain @click="documentTypebtn(1)">上传文档</el-button>
      <el-button type="primary" plain @click="documentTypebtn(2)">上传视频</el-button>
      <!-- <el-button type="primary" plain @click="documentTypebtn(3)">上传图片</el-button>
      <el-button type="primary" plain @click="documentTypebtn(4)">上传音频</el-button> -->
    </div>

    <div class="centerul">
      <div class="centerli" v-for="(item,index) in certifiData" :key="index">
        <img :src="item.imgUrl" class="centerImg" />
        <div class="centerRight">
          <div class="centerRihed">
            <div class="centerRititle">{{item.name}}</div>
            <div class="centerRiheddel" v-if="item.state !=1" @click="rouserDel(item.id)">删除</div>
          </div>
          <div v-if="item.state ==0" class="audits">待审核</div>
          <div v-if="item.state ==1" class="audits">审核通过</div>
          <div v-if="item.state ==-1" class="audits">审核未通过</div>
          <div class="cartdate">上传时间：{{item.createTime}}</div>
        </div>
      </div>
    </div>

    <el-dialog
      class="dialog-mini"
      title="请选择要上传资源"
      :visible.sync="dialogVisible"
      width="30%"
      top="30vh"
      :show-close="true"
      :close-on-click-modal="false"
      v-if="dialogVisible"
    >
      <el-form>
        <div style="display:flex">
          <el-form-item>
            <elSelectc
              style="max-width:150px"
              clearable
              :placeDefult="'资源类型'"
              :NamespaceId="51"
              :key="sid"
              :typeNames="formData.classDicId"
              :typeids="formData.classDicId"
              @selectData="selectDataClassDicId"
            ></elSelectc>
          </el-form-item>

          <el-form-item style="margin-left:15px">
            <elSelectc
              clearable
              style="max-width:150px"
              :placeDefult="'警种'"
              :NamespaceId="1"
              :key="sid"
              :typeNames="formData.jzDicId"
              :typeids="formData.jzDicId"
              @selectData="selectDatajzDicId"
            ></elSelectc>
          </el-form-item>
        </div>
      </el-form>

      <div class="train-container">
        <el-upload
          :headers="headers"
          class="upload-demo"
          ref="upload"
          drag
          :limit="1"
          :auto-upload="true"
          :show-file-list="true"
          action="/resource/File/UploadFile"
          :on-success="handupload"
          :on-remove="handremove"
          :on-progress="handpro"
          :on-exceed="handleExceed"
          :accept="accept"
          :file-list="fileLists"
          :multiple="true"
          :before-upload="beforeimagesuccess"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
        </el-upload>
        <div class="format-box">
          <span style="color: #F59A23;margin-top: 10px;">温馨提示</span>

          <div class="el-upload__text">1. 上传过程中若关闭当前页面有可能导致资源上传失败</div>
          <div class="el-upload__text">2. 一次可同时上传的文件不超过1个，上传的单个文件不超过1G</div>

          <div class="el-upload__text" v-if="formData.documentType==2">3. 支持的视频上传格式：mp4</div>

          <div
            class="el-upload__text"
            v-else-if="formData.documentType==1"
          >3. 支持的文档上传格式：pdf</div>
          <div
            class="el-upload__text"
            v-else-if="formData.documentType==3"
          >3. 支持的图片上传格式：jpg、png、svg、bmp、jpeg、gif</div>
          <div class="el-upload__text" v-else-if="formData.documentType==4">3. 支持的音频上传格式：mp3</div>
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="dialogVisible = false">取消</el-button>
        <el-button size="mini" :disabled="flag?false:true" type="primary" @click="createupload">确认</el-button>
      </div>
    </el-dialog>
    <el-pagination
      background
      prev-text="上一页"
      next-text="下一页"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="listQuerys.page"
      :page-size="listQuerys.limit"
      layout=" total,prev, pager, next,jumper"
      :total="total"
      v-if="total>10"
    />
  </div>
</template>
<script>
import * as educat from '@/api/personcenter/index.js';
import * as resourceapp from '@/api/resources/index.js';
import elSelectc from '@/components/elSelect';
import { getInfo} from '@/utils/auth';
export default {
  components: {
    elSelectc,
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      accept: null,
      formData: {
        id: 0,
        name: '',
        documentType: null, //1文段，2视频,3图片,4音频
        documentPath: '', //文件上传路径
        imgUrl: '', //封面图
        context: '', //介绍,描述
        classDicId: null, //文件标签类型
        jzDicId: null, //警种
        createId: JSON.parse(getInfo('infos')).id,
        createName: JSON.parse(getInfo('infos')).name,
      },
      flag: false,
      fileLists: [],
      sid: +new Date(),
      listQuerys: {
        page: 1,
        limit: 10,
        userId: JSON.parse(getInfo('infos')).id,
      },
      total: 0,
      certifiData: [],
    };
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + this.$store.getters.tokens,
      };
    },
    getinfo() {
      return this.$store.state.User.infos;
    },    
  },
  created() {
    this.getList();
  },
  methods: {
    // 删除
    rouserDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        resourceapp.Deleteload([id]).then((res) => {
          console.log(res);
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success',
            duration: 2000,
          });
          this.getList();
        });
      });
    },
    selectDataClassDicId(val) {
      // console.log(val);
      this.formData.classDicId = val.value;
      this.formData.classDicName = val.label;
    },
    selectDatajzDicId(val) {
      // console.log(val);
      this.formData.jzDicId = val.value;
      this.formData.jzDicName = val.label;
    },
    // 点击上传
    documentTypebtn(val) {
      this.fileLists = [];
      this.formData = {
        id: 0,
        name: '',
        documentType: null, //1文段，2视频,3图片,4音频
        documentPath: '', //文件上传路径
        imgUrl: '', //封面图
        context: '', //介绍,描述
        classDicId: null, //文件标签类型
        createId: JSON.parse(getInfo('infos')).id,
        createName: JSON.parse(getInfo('infos')).name,
        jzDicId: '',
      };

      this.dialogVisible = true;
      this.formData.documentType = val;
      //限制上传的文件格式
      if (val == 1) {
        // 上传的是文档
        // this.accept = '.doc,.docx,.pdf,.ppt,.xls,.xlsx';
        this.accept = '.pdf';
      } else if (val == 2) {
        // this.accept = '.mp4,.flv,.avi,.rmvb';
        this.accept = '.mp4';
      } else if (val == 3) {
        this.accept = '.jpg,.jpeg,.png,.bmp,.svg,.gif';
      } else if (val == 4) {
        this.accept = '.mp3';
      }
    },
    // 确认上传
    createupload() {
      if (!this.formData.classDicId) {
        this.$message.error('请选择资源类型');
        return false;
      }
      if (!this.formData.jzDicId) {
        this.$message.error('请选择警种');
        return false;
      }

      if (this.flag == true) {
        this.dialogVisible = false;
      } else {
        this.$message.warning(`未上传，完成请稍等`);
      }

      this.onSubmit();
    },
    handupload(response, file, fileList) {
      let type = this.formData.documentType;
      // console.log(fileList);
      this.flag = true;
      this.fileLists = fileList;
      let fileName = file.name.substring(0, file.name.lastIndexOf('.'));
      // console.log(fileName);

      // if (type == 2) {
      //   let FileSize = this.getCaption(response.result);
      //   this.formData.FileSize = FileSize;
      // }

      if (fileName.length > 20) {
        this.$notify({
          title: '警告',
          message: '上传文件名称过长,系统只截取前二十位字符',
          type: 'warning',
          duration: 2000,
        });
        this.formData.name = fileName.substring(0, 19);
      } else {
        this.formData.name = fileName;
      }

      // if (type == 2) {
      //   let result = file.response.result;
      //   let opt = result.indexOf(',');
      //   let url = result.substring(0, opt);
      //   this.formData.documentPath = url;
      // } else {
      //   this.formData.documentPath = file.response.result;
      // }

      this.formData.documentPath = file.response.result;
    },
    getCaption(obj) {
      var index = obj.lastIndexOf(',');
      obj = obj.substring(index + 1, obj.length);
      return obj;
    },
    // 大小进行验证/
    beforeimagesuccess(file) {
      const isLt2M = file.size / 1024 / 1024 < 1000;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 1G!');
        return false;
      }
    },
    // 删除
    handremove(file, fileList) {
      console.log(file, fileList);
    },
    handpro(event, file, fileList) {
      this.flag = false;
      // console.log(event);
    },
    handpro(event, file, fileList) {
      this.flag = false;
      // console.log(event);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    onSubmit() {
      this.loading = true;
      resourceapp.docmAddMore([this.formData]).then((res) => {
        this.loading = false;
        if ((res.message = '操作成功')) {
          //当上传的资源是视频时需要调取转码接口
          if (this.formData.documentType == 2) {
            //因为上传的是数组，调取的接口需要是单个对象，所以要循环调取转码接口

            let para = {
              objId: res.result[0],
              objType: 1,
              path: this.formData.documentPath,
            };
            console.log(para);
            resourceapp.ProgressConvertM3U8(para).then((resl) => {});
          }
          this.$notify({
            title: '成功',
            message: '添加成功',
            type: 'success',
            duration: 2000,
          });
          this.getList();
        }
      });
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.listQuerys.limit = val;
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.listQuerys.page = val;
      this.getList();
    },
    getList() {
      resourceapp.getuploadFileListApi(this.listQuerys).then((res) => {
        this.certifiData = res.data;
        this.total = res.count;
      });
    },
  },
};
</script>
<style scoped>
.content {
  width: 900px;
  padding-bottom: 20px;
}

.header {
  display: flex;
  padding: 20px 0;
  margin: 0 20px;
  border-bottom: 1px solid #f2f2f2;
}

.centerul {
  display: flex;
  flex-wrap: wrap;
}
.centerli {
  width: 407px;
  border: 1px solid #f2f2f2;
  cursor: pointer;
  margin: 20px 0 0 14px;
  border-radius: 5px;
  display: flex;
  padding: 10px;
}
.centerImg {
  width: 90px;
  height: 90px;
}
.centerRihed {
  display: flex;
}
.centerRititle {
  font-size: 16px;
  color: #333;
  flex: 1;
  height: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*控制在3行*/
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.centerRight {
  flex: 1;
  padding-left: 10px;
}
.centerRiheddel {
  width: 70px;
  height: 25px;
  color: #fff;
  text-align: center;
  line-height: 25px;
  background-color: #f56c6c;
  border-radius: 12px;
}
.cartdate {
  font-size: 14px;
  color: #888;
  padding-top: 10px;
}
.audits {
  text-align: right;
}
</style>